import { FC, useState, useRef, useEffect } from "react";
import { Box, Flex } from "@otrium/core";
import { FiltersButton } from "../FiltersButton";
import { MobileSortByFilter } from "../MobileSortByFilter";
import { Sticky } from "src/atoms/Sticky";

interface Props {
  excludedFacetsList?: string[];
  sortValue: string;
  handleSelect: (value: string) => void;
  handleOpenModal: (value: boolean) => void;
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}

const MobileFiltersButtonAndSortWrapper: FC<Props> = ({
  excludedFacetsList = [],
  sortValue,
  handleSelect,
  handleOpenModal,
  keepSelectedIgnoreInActive,
  selectedCatSlug,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [offsetTop, setOffsetTop] = useState<number | null>(null);
  useEffect(() => {
    const offset = contentRef?.current?.getBoundingClientRect()?.top;
    if (offset) {
      setOffsetTop(offset);
    }
  }, [contentRef, offsetTop, setOffsetTop]);

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const incrementedTopOffset = offsetTop ? offsetTop + offsetTop / 2 : 0;

  return (
    <Box px={["space16", "space16", "space16", "space0"]}>
      {offsetTop !== null &&
      offsetTop > 0 &&
      scrollPosition >= incrementedTopOffset ? (
        <Sticky offsetTop={-offsetTop} top={55} boxshadowMode={"down"}>
          <Flex
            margin="auto -4px;"
            p={3}
            alignItems="center"
            justifyContent="space-between"
          >
            <Box onClick={() => handleOpenModal(true)}>
              <FiltersButton
                excludedFacetsList={excludedFacetsList}
                keepSelectedIgnoreInActive={keepSelectedIgnoreInActive}
                selectedCatSlug={selectedCatSlug}
              />
            </Box>

            <MobileSortByFilter
              sortValue={sortValue}
              handleSelect={handleSelect}
            />
          </Flex>
        </Sticky>
      ) : (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          ref={contentRef}
          margin="auto -4px;"
        >
          <Box onClick={() => handleOpenModal(true)}>
            <FiltersButton
              excludedFacetsList={excludedFacetsList}
              keepSelectedIgnoreInActive={keepSelectedIgnoreInActive}
              selectedCatSlug={selectedCatSlug}
            />
          </Box>

          <MobileSortByFilter
            sortValue={sortValue}
            handleSelect={handleSelect}
          />
        </Flex>
      )}
    </Box>
  );
};

export default MobileFiltersButtonAndSortWrapper;
